// @flow
import React from 'react';
import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import * as styles from './FooterMobile.module.scss';
import ArrowDownIcon from '../../images/arrow-down';
import Logo from '../../images/logo-white.svg';
import BadgeAppStore from '../../images/badge-app-store.svg';
import BadgeGooglePlay from '../../images/badge-google-play.svg';
import IconTwitter from '../../images/icon-twitter-white.svg';
import IconLinkedin from '../../images/icon-linkedin.svg';

const Footer = () => {
  return (
    <div className={styles.footerWrapper}>
      <footer>
        <Link to="/">
          <img
            className={styles.logo}
            src={Logo}
            alt="Paidy"
            height="40"
            width="77"
            loading="lazy"
          />
        </Link>
        <nav className={styles.app}>
          <a
            title="Paidy | App Store"
            className={styles.badge}
            href="https://apps.apple.com/jp/app/paidy/id1220373112"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              if(window.dataLayer) {
                window.dataLayer.push({
                  event: 'app_download',
                  ga_click_area: 'footer',
                  ga_platform: 'App Store',
                })
              }
            }}
          >
            <img
              src={BadgeAppStore}
              alt="Paidy | App Store"
              width="140"
              height="42"
              loading="lazy"
            />
          </a>
          <a
            title="Paidy | Google Play"
            className={styles.badge}
            href="https://play.google.com/store/apps/details?id=com.paidy.paidy&hl=ja"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              if(window.dataLayer) {
                window.dataLayer.push({
                  event: 'app_download',
                  ga_click_area: 'footer',
                  ga_platform: 'Google Play',
                })
              }
            }}
          >
            <img
              src={BadgeGooglePlay}
              alt="Paidy | Google Play"
              width="140"
              height="42"
              loading="lazy"
            />
          </a>
        </nav>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDownIcon />}
            aria-controls="できること-content"
            id="できること-header"
          >
            <div className={styles.title}>できること</div>
          </AccordionSummary>
          <AccordionDetails>
            <nav>
              <Link to="/payments/">Paidy翌月払いとは</Link>
              <Link to="/payments/#flow">ご利用方法</Link>
              <Link to="/security/">安全への取り組み</Link>
              <Link to="/payments/#campaign">キャンペーン情報</Link>
              <OutboundLink
                title="Paidy | ヘルプ"
                className={styles.badge}
                href="https://support.paidy.com/hc/ja"
                target="_blank"
                rel="noopener noreferrer"
              >
                ヘルプ
              </OutboundLink>
              <OutboundLink
                title="Paidy | T&C"
                className={styles.badge}
                href="https://terms.paidy.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                利用規約
              </OutboundLink>
            </nav>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDownIcon />}
            aria-controls="使えるお店-content"
            id="使えるお店-header"
          >
            <div className={styles.title}>使えるお店</div>
          </AccordionSummary>
          <AccordionDetails>
            <nav>
              <Link to="/shop/">お店紹介</Link>
              <Link to="/shop/list/">お店一覧</Link>
              <Link to="/shop/#editors_pick">ピックアップアイテム</Link>
              <Link to="/shop/#popular_shops">おすすめのお店</Link>
            </nav>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDownIcon />}
            aria-controls="会社プロフィール-content"
            id="会社プロフィール-header"
          >
            <div className={styles.title}>会社プロフィール</div>
          </AccordionSummary>
          <AccordionDetails>
            <nav>
              <Link to="/company/#company_overview">会社概要</Link>
              <Link to="/company/#teams">マネジメントチーム</Link>
              <OutboundLink
                href="https://careers.paidy.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                採用情報
              </OutboundLink>
            </nav>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDownIcon />}
            aria-controls="法人のお客様-content"
            id="法人のお客様-header"
          >
            <div className={styles.title}>法人のお客様</div>
          </AccordionSummary>
          <AccordionDetails>
            <nav>
              <Link to="/merchant/">法人のお客様</Link>
              <Link to="/merchant/#case_study">導入事例</Link>
              <Link to="/merchant/contact_us/">法人/PRお問合せ</Link>
            </nav>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDownIcon />}
            aria-controls="導入について-content"
            id="導入について-header"
          >
            <div className={styles.title}>導入について</div>
          </AccordionSummary>
          <AccordionDetails>
            <nav className={styles.integrate}>
              <Link to="/merchant/application/#documents">導入申込み</Link>
              <OutboundLink href="/docs/jp/" rel="noopener noreferrer" target="_blank">
                技術ドキュメント
              </OutboundLink>
              <OutboundLink
                href="https://merchant.paidy.com/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                加盟店ログイン
              </OutboundLink>
            </nav>
          </AccordionDetails>
        </Accordion>
        <div className={styles.misc}>
          <nav className={styles.sns}>
            <OutboundLink
              className={styles.badge}
              href="https://twitter.com/paidyjp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={IconTwitter} alt="Paidy | Twitter" width="30" height="24" loading="lazy" />
            </OutboundLink>
            <OutboundLink
              className={styles.badge}
              href="https://www.linkedin.com/company/paidy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={IconLinkedin}
                alt="Paidy | Linkedin"
                width="30"
                height="24"
                loading="lazy"
              />
            </OutboundLink>
          </nav>
          <small>&copy; Paidy Inc.</small>
        </div>
      </footer>
    </div>
  );
};

Footer.defaultProps = { isMerchant: false };

export default Footer;
